// Static blog metadata and excerpts for previews
// Author for all posts
export const BLOG_AUTHOR = "Chris Olsen";

// Note: Background color for previews is handled in CSS.

export const BLOG_POSTS = [
  {
    id: "blog_01",
    title: "Troubleshooting a Failing Chandelier: Why the Right Transformer Matters",
    date: "March 29, 2025",
    excerpt:
      "A recent service call led me to a chandelier repair job that wasn’t quite living up to its potential. Out of the eight lights in the fixture, only three were still working — not ideal for a centerpiece that’s supposed to brighten up a room. Once I had the fixture down and opened it up, the cause became clear: a failed transformer. After a closer look, it was obvious the transformer was undersized for the load it was supporting...",
  },
  {
    id: "blog_02",
    title:
      "The Dangers of Undersized Conductors Connected to Appliances in Homes and Businesses",
    date: "July 19, 2024",
    excerpt:
      "Electrical safety is paramount in both residential and commercial settings. One critical aspect of ensuring electrical safety is using appropriately sized conductors for various appliances and electrical systems. Undersized conductors pose significant risks, leading to potential hazards such as overheating, voltage drop, and equipment damage...",
  },
  {
    id: "blog_03",
    title: "The Dangers of Overloading Circuits and Receptacles",
    date: "July 15, 2024",
    excerpt:
      "Overloading circuits and receptacles in our homes or businesses can lead to serious safety hazards. At Megavolt Electric, our experienced electricians frequently encounter issues with portable air conditioning units, which typically draw a significant amount of current from a 15A circuit. Many people don’t realize that running multiple high-draw devices...",
  },
  {
    id: "blog_04",
    title:
      "The Dangers of Water and Electricity and the Importance of GFCI Protection",
    date: "July 5, 2024",
    excerpt:
      "Water and electricity are a dangerous combination. When they come into contact, the risk of electrical shock and serious injury is significantly heightened. Understanding the dangers and taking preventative measures, such as using Ground Fault Circuit Interrupters (GFCIs), is crucial for ensuring safety at home and at work...",
  },
  {
    id: "blog_05",
    title:
      "The Benefits of Upgrading to LED Lighting for Homes and Businesses",
    date: "June 27, 2024",
    excerpt:
      "The Benefits of Upgrading to LED Lighting for Homes and Businesses LED lighting has become increasingly popular due to its energy efficiency and long lifespan. As an electrical service provider in Calgary, Megavolt Electric is here to help you understand why upgrading to LED lighting is a smart choice...",
  },
  {
    id: "blog_06",
    title: "The Importance of a Neat and Organized Electrical Panel",
    date: "June 20, 2024",
    excerpt:
      "When you think about electrical systems in homes or businesses, the first things that come to mind might be outlets, switches, and light fixtures. However, the true heart of any electrical system lies behind the scenes, often concealed by finished walls and ceilings. One crucial component that remains out of sight — but should never be out of mind...",
  },
  {
    id: "blog_07",
    title: "The Impact of Lighting on Your Home and Workspaces",
    date: "June 3, 2024",
    excerpt:
      "At Megavolt Electric, we understand that lighting is more than just a necessity; it plays a crucial role in defining the atmosphere and functionality of any space. Whether in your home or workplace, the right lighting can transform the environment, enhance mood, and improve productivity. Creating the right balance...",
  },
  {
    id: "blog_08",
    title: "When You Might Need to Add a Sub-Panel",
    date: "April 17, 2024",
    excerpt:
      "Adding a Sub-Panel with Megavolt Electric in Calgary Adding a sub-panel to an existing electrical panel can be a smart solution for expanding electrical capacity in your home or workspace. Here’s a brief overview of the benefits and scenarios where it might be necessary: Benefits of Adding a Sub-Panel include better load distribution and future expansion...",
  },
  {
    id: "blog_09",
    title:
      "Upgrade Your Home Lighting to Recessed LED with Megavolt Electric in Calgary!",
    date: "March 25, 2024",
    excerpt:
      "Considering a lighting overhaul? Think recessed LED lighting for an instant upgrade! Here’s why: Energy Efficiency: LED lights consume significantly less energy than traditional bulbs, slashing your electricity bills while reducing your carbon footprint. With Megavolt Electric in Calgary, you can expect professional installation and advice...",
  },
  {
    id: "blog_10",
    title: "Why I should consider buying a doorbell camera",
    date: "March 20, 2024",
    excerpt:
      "24/7 Surveillance: Keep a vigilant eye on your property day and night. Megavolt Electric’s doorbell cameras offer round-the-clock surveillance, providing peace of mind even when you’re away from home. Remote Monitoring: Whether you’re at work, on vacation, or simply running errands, you can check in and communicate with visitors through your smartphone...",
  },
  {
    id: "blog_11",
    title:
      "Retrofitting Older Homes with Modern LED Lighting Made Simple",
    date: "August 14, 2023",
    excerpt:
      "Gone are the days when integrating modern LED fixtures into older homes was a cumbersome affair. The evolution in LED technology has made retrofitting not just simpler, but also aesthetically more pleasing. Thanks to companies like Megavolt Electric in Calgary, retrofitting LED lights into older homes can be done cleanly and efficiently...",
  },
  {
    id: "blog_12",
    title:
      "Megavolt Electric’s Trusted Tool: The Fluke 1AC II Non-Contact Voltage Tester",
    date: "August 11, 2023",
    excerpt:
      "At Megavolt Electric, we have a staunch commitment to ensuring safety and precision in all our electrical services. Over the years, our go-to instrument for detecting electrical presence has been the Fluke 1AC II Non-Contact Voltage Tester. It’s not just a tool for us; it’s a partner we trust in the field for quick, reliable checks...",
  },
  {
    id: "blog_13",
    title:
      "Why Choosing Megavolt Electric in Calgary Can Transform Your Next Electrical Project",
    date: "August 8, 2023",
    excerpt:
      "We’ve all been there. You have an electrical project that needs to be done, but the thought of finding the right company feels daunting. You don’t just want the job completed; you want it done right and without any hassles. Enter Megavolt Electric, a beacon of excellent customer service and unmatched workmanship...",
  },
  {
    id: "blog_14",
    title:
      "Understanding When to Replace Your Electrical Panel: A Guide from Megavolt Electric",
    date: "August 7, 2023",
    excerpt:
      "Many homeowners and businesses often question if an aging electrical panel needs to be replaced. Simply being older, however, does not necessarily mean it is in need of replacement. A well-installed electrical panel, particularly when done by experienced, licensed electricians like those at Megavolt Electric, can serve reliably for many years...",
  },
  {
    id: "blog_15",
    title:
      "Why you should choose Megavolt Electric for your next home renovation!",
    date: "August 3, 2023",
    excerpt:
      "Choosing Megavolt Electric for your next home renovation in Calgary is a decision you won’t regret. With our experienced electricians and relentless commitment to quality, we guarantee that all of our projects meet or exceed code requirements. At Megavolt Electric, customer service isn’t just a promise — it’s how we operate every day...",
  },
  {
    id: "blog_16",
    title:
      "Ensure Safety with Megavolt Electric: Experienced Electricians for Comprehensive Electrical Inspections",
    date: "July 30, 2023",
    excerpt:
      "When it comes to ensuring the safety and efficiency of your home or business’s electrical systems, choosing the right professionals for inspection and maintenance is crucial. Megavolt Electric, a licensed electrical company in Calgary, offers top-notch services that cater to various needs and demands...",
  },
  {
    id: "blog_17",
    title:
      "Megavolt Electric: Your Go-to Expert Electricians for Renovations and Repair Work in Calgary",
    date: "July 28, 2023",
    excerpt:
      "Looking for dependable, high-quality electrical services in Calgary? Look no further. At Megavolt Electric, we are dedicated to meeting and surpassing your expectations. As local and experienced electricians, we provide an unparalleled blend of technical expertise, customer service, and commitment to excellence...",
  },
  {
    id: "blog_18",
    title:
      "Empowering Your Spaces with Megavolt Electric — Updating Receptacles for a Modern Edge",
    date: "July 27, 2023",
    excerpt:
      "In an ever-evolving tech landscape, upgrading your residential or commercial spaces with modern electrical receptacles has become more than just a luxury — it’s a necessity. Fortunately, for those situated in Calgary, the solution is a quick call away. Megavolt Electric, backed by a team of experienced electricians, can help modernize and secure your outlets...",
  },
  {
    id: "blog_19",
    title: "Enjoy the Ultimate Relaxation Experience with Megavolt Electric",
    date: "July 26, 2023",
    excerpt:
      "Are you dreaming of relaxing in your personal hot tub under the starry sky of Calgary? Imagine the warm water embracing your body as you sit back, and your worries slowly melt away. Now, it’s time to turn your dream into reality. The key? Megavolt Electric is the trusted name when it comes to hot tub power and safe outdoor electrical setups...",
  },
  {
    id: "blog_20",
    title:
      "The Capacity of Experienced Electricians to Update Electrical Systems in Finished and Unfinished Spaces: Megavolt Electric at Your Service",
    date: "July 24, 2023",
    excerpt:
      "For any home or business, an efficient, modern, and safe electrical system is not just an amenity, it’s a necessity. Electrical updates and maintenance should never be overlooked, as they play an integral role in ensuring the functionality and safety of your space. But updating an electrical system in finished or unfinished walls and ceilings...",
  },
].map((p) => ({ ...p, author: BLOG_AUTHOR }));

export default BLOG_POSTS;
